"use client";

import React from "react";
import ButtonLinkNext from "@sendsprint/ui-react/components/buttonLinkNext";
import useCampaign from "@/hooks/utils/useCampaign";

interface Props {
  label?: string;
}

const SendMoneyButton = ({ label = "Send Money" }: Props) => {
  const { registerLink, handleClearCampaignId } = useCampaign();

  return (
    <ButtonLinkNext
      href={registerLink}
      onClick={handleClearCampaignId}
      label={label}
      radius="full"
      // @ts-ignore
      target="_blank"
    />
  );
};

export default SendMoneyButton;
